import { IFile, IFileInfo, FileType } from '@tencent/docs-api';

export default class File implements IFile {
    private static instance: IFile;
    public static getInstance(): IFile {
        if (!this.instance) {
            this.instance = new File();
        }

        return this.instance;
    }

    public getFileInfo(): IFileInfo {
        const { globalPadId, title, creatorId } = window.clientVars;
        return {
            id: globalPadId,
            name: title,
            type: FileType.SLIDE,
            creatorId,
        };
    }
}
